import auth from "./auth"
import application from "./application"
import applicationbundle from "./application_bundle"
import applicationtemplate from "./application_template"
import attachment from "./attachment"
import user from "./user"
import affiliate from "./affiliate"
import referral from "./referral"
import report from "./report"
import account from "./account"
import transaction from "./transaction"
import company from "./company"
import notification from "./notification"
import documenttemplate from "./document_template"
import documentsigning from "./document_signing"

export default {
  auth,
  user,
  application,
  applicationbundle,
  applicationtemplate,
  attachment,
  affiliate,
  referral,
  report,
  account,
  transaction,
  company,
  notification,
  documenttemplate,
  documentsigning
}
